<template>
  <nav class="flex items-center justify-between border-gray-200 px-4 sm:px-4">
    <div class="-mt-px flex w-0 flex-1">
            <span v-if="pagination.prev_page_url" @click="paginate(pagination.prev_page_url)"
                  class="inline-flex items-center border-t-2 border-transparent pt-4 pr-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 cursor-pointer">
                <ArrowNarrowLeftIcon class="mr-3 h-5 w-5 text-gray-400" aria-hidden="true"/>
                {{ __('Previous') }}
            </span>
      <span v-else
            class="inline-flex items-center border-t-2 border-transparent pt-4 pr-1 text-sm font-medium text-gray-300">
                <ArrowNarrowLeftIcon class="mr-3 h-5 w-5 text-gray-200" aria-hidden="true"/>
                {{ __('Previous') }}
            </span>
    </div>
    <div class="hidden md:-mt-px md:flex">
      <template v-for="(link, idX) in pagination.links" :key="idX">
                <span
                    v-if="link.url && isNumber(link.label)"
                    @click="paginate(link.url)"
                    v-html="link.label"
                    :class="{'border-primary-500 text-primary-500': link.active, 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 text-gray-500 hover:border-gray-300 hover:text-gray-700': !link.active}"
                    class="inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium cursor-pointer"
                />
        <span
            v-else-if="isNumber(link.label)"
            v-html="link.label"
            :class="{'border-primary-500 text-primary-500': link.active, 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300': !link.active}"
            class="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
        />
      </template>
    </div>
    <div class="-mt-px flex w-0 flex-1 justify-end">
            <span v-if="pagination.next_page_url" @click="paginate(pagination.next_page_url)"
                  class="inline-flex items-center border-t-2 border-transparent pt-4 pl-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 cursor-pointer">
                {{ __('Next') }}
                <ArrowNarrowRightIcon class="ml-3 h-5 w-5 text-gray-400" aria-hidden="true"/>
            </span>
      <span v-else
            class="inline-flex items-center border-t-2 border-transparent pt-4 pl-1 text-sm font-medium text-gray-300">
                {{ __('Next') }}
                <ArrowNarrowRightIcon class="ml-3 h-5 w-5 text-gray-200" aria-hidden="true"/>
            </span>
    </div>
  </nav>
</template>

<script>
import {ArrowNarrowLeftIcon, ArrowNarrowRightIcon} from '@heroicons/vue/solid'
import Button from "@/Jetstream/Button.vue";

export default {
  components: {Button, ArrowNarrowLeftIcon, ArrowNarrowRightIcon},
  props: {
    pagination: {
      type: Object,
    },
    pageKey: {
      default: 'page'
    },
    preserveState: {
      default: true
    }
  },
  methods: {
    paginate(uri) {
      var page = this.parameterOf(this.pageKey, uri);
      console.log(page, this.pageKey, uri);
      this.$inertia.get(location.href, {
        [this.pageKey]: page,
      }, {
        preserveState: this.preserveState,
      })
    },
    parameterOf(name, uri) {
      if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(uri))
        return decodeURIComponent(name[1]);
    },
    isNumber(page) {
      return !isNaN(page);
    }
  }
}
</script>
